import type { RezaOpravneniDto } from '@gov-nx/api';
import { useActiveRezaItem } from '@gov-nx/core/hooks';

enum CustomEnum {
	'[ic]' = '[ic]',
}
export const useCustomEnumValues = () => {
	const activeRezaItem = useActiveRezaItem();

	const customEnumParameterValues = (reza: RezaOpravneniDto | undefined) => ({
		[CustomEnum['[ic]']]: reza?.zastupujiciOsoba?.pravnickaOsoba?.ico || '',
	});

	const customEnumValues = customEnumParameterValues(activeRezaItem);

	return {
		customEnumValues,
		customEnumValuesKeys: Object.keys(customEnumValues),
	};
};
